/**
 * Firebase Configuration
 *
 * This file contains the Firebase configuration and initialized services.
 * It handles initialization logic to prevent multiple Firebase app instances.
 */

import { initializeApp, getApps, getApp, type FirebaseApp } from 'firebase/app';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { getDatabase, type Database } from 'firebase/database';
import { getAuth, type Auth } from 'firebase/auth';
import { getAnalytics, type Analytics } from 'firebase/analytics';

/**
 * Firebase configuration object interface
 */
export interface FirebaseConfig {
    /** Firebase API key */
    apiKey: string;
    /** Firebase Auth domain */
    authDomain: string;
    /** Firebase Realtime Database URL */
    databaseURL: string;
    /** Firebase project ID */
    projectId: string;
    /** Firebase storage bucket */
    storageBucket: string;
    /** Firebase messaging sender ID */
    messagingSenderId: string;
    /** Firebase app ID */
    appId: string;
    /** Google Analytics measurement ID */
    measurementId: string;
}

/**
 * Firebase configuration for the GreenShepherd VPP platform
 */
export const firebaseConfig: FirebaseConfig = {
    apiKey: "AIzaSyCWj0HML0vk2vqu0ysj6eCLddbmG1l80WM",
    authDomain: "greenshepherdcomtw.firebaseapp.com",
    databaseURL: "https://greenshepherdcomtw-default-rtdb.firebaseio.com",
    projectId: "greenshepherdcomtw",
    storageBucket: "greenshepherdcomtw.appspot.com",
    messagingSenderId: "219264788569",
    appId: "1:219264788569:web:0e693dac755ba34e56a948",
    measurementId: "G-BBF99VD24R"
};

/** Firebase app instance - reuses existing app if already initialized */
const app: FirebaseApp = !getApps().length ? initializeApp(firebaseConfig) : getApp();

/** Firebase Authentication instance */
export const auth: Auth = getAuth(app);

/** Firestore database instance (default database) */
export const db: Firestore = getFirestore(app);

/** Firestore database instance (using 'db-om' database) */
export const dbOm: Firestore = getFirestore(app, "db-om");

/** Firebase Realtime Database instance */
export const realtimeDb: Database = getDatabase(app);

/** Google Analytics instance */
export const analytics: Analytics = getAnalytics(app);

export default {
    firebaseConfig,
    auth,
    db,
    dbOm,
    realtimeDb,
    analytics
};
